// extracted by mini-css-extract-plugin
export default {"field":"Editor_field__A+jBU","text":"Editor_text__zolDF"};